module.exports = require('./backbone.supermodel.coffee')
